// Navigation bookkeeping only; the durable score event remains the source of truth.
// A first finish may offer a moment once. History and corrections never create one.
const volatile = new Map()
const key = (scope) => `${scope}:completion`
export function beginRacquetCompletion(scope, eventId) {
  try {
    localStorage.setItem(key(scope), eventId)
    volatile.delete(scope)
  } catch {
    volatile.set(scope, eventId)
  }
}
export function hasRacquetCompletion(scope, events) {
  let id = volatile.get(scope)
  if (!volatile.has(scope)) {
    try {
      id = localStorage.getItem(key(scope))
    } catch {}
  }
  return Boolean(id && events.some((event) => event.id === id))
}
export function consumeRacquetCompletion(scope) {
  try {
    localStorage.removeItem(key(scope))
    volatile.delete(scope)
  } catch {
    volatile.set(scope, null)
  }
}
